var toArray = require('../../toArray'); // .files fallback, should be implemented in any browser


module.exports = function fallbackApi(dataTransfer) {
  var files = toArray(dataTransfer.files);
  return Promise.resolve(files);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/utils/lib/getDroppedFiles/utils/fallbackApi.js
// module id = 1247
// module chunks = 0